import { FC } from 'react';
import styles from './BookBreadcrumbs.module.scss';
import Link from 'next/link';
// import { parseISO, format } from 'date-fns';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

import { IBookDetailGenre } from '@/interfaces/bookDetail.interface';

interface IBookBreadcrumbs {
  bookTitle: string;
  bookId: number;
  genres?: IBookDetailGenre[];
  authorFullName: string;
  authorId: number;
  createdAt?: string;
}

const BookBreadcrumbs: FC<IBookBreadcrumbs> = ({ bookTitle, bookId, authorFullName, authorId, genres, createdAt }) => {
  const currentPath = String(useGetUrlPath());

  const getReadBookPageUrl = () => {
    if (currentPath.includes('/read')) {
      return true;
    }
  };

  const isReadOnlinePage = getReadBookPageUrl();

  const getBookBreadcrumbs = () => {
    if (!!isReadOnlinePage) {
      return {
        __html: `{
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type": "ListItem","position": 1,"name": "Главная","item": "https://fantasy-worlds.ru"},
          {"@type": "ListItem","position": 2,"name": "${authorFullName}","item": "https://fantasy-worlds.ru/author/id${authorId}"},
          {"@type": "ListItem","position": 3,"name": "${bookTitle}", "item": "https://fantasy-worlds.ru/lib/id${bookId}"},
          {"@type": "ListItem","position": 4,"name": "Читать онлайн"}
         ]
      }`,
      };
    } else {
      return {
        __html: `{
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type": "ListItem","position": 1,"name": "Главная","item": "https://fantasy-worlds.ru"},
          {"@type": "ListItem","position": 2,"name": "${authorFullName}","item": "https://fantasy-worlds.ru/author/id${authorId}"},
          {"@type": "ListItem","position": 3,"name": "${bookTitle}"}
         ]
      }`,
      };
    }
  };

  return (
    <>
      {!!genres!.length && <script type="application/ld+json" dangerouslySetInnerHTML={getBookBreadcrumbs()} key="product-jsonld" />}

      <div className={styles.breadcrumbsListWrap}>
        <ul className={styles.breadcrumbsList}>
          <li className={styles.breadcrumbsList__item}>
            <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href="/">
              Главная
            </Link>
          </li>
          <li className={styles.breadcrumbsList__item}>
            {'📚 '}
            <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`/author/id${authorId}/`}>
              {authorFullName}
            </Link>
          </li>

          {!!isReadOnlinePage ? (
            <>
              <li className={styles.breadcrumbsList__item}>
                {'▶ '}
                <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={`/lib/id${bookId}`}>
                  {bookTitle}
                </Link>
              </li>
              <li className={styles.breadcrumbsList__item}>▶ Читать онлайн</li>
            </>
          ) : (
            <li className={styles.breadcrumbsList__item}>{`▶ ${bookTitle}`}</li>
          )}
        </ul>
      </div>
    </>
  );
};

export default BookBreadcrumbs;
